<template>
  <div class="dashboard-sidebar-widgets">
    <ListMuralPosts v-if="$root.user.isClient" />
    <ListMedals v-if="$root.user.isClient" />
  </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";

const ListMedals = defineAsyncComponent(() =>
  import("../medals/ListMedals.vue")
);
const ListMuralPosts = defineAsyncComponent(() =>
  import("../posts/ListMuralPosts.vue")
);
</script>
